import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-services-subsection-card',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './services-subsection-card.component.html',
  styleUrl: './services-subsection-card.component.css'
})
export class ServicesSubsectionCardComponent {
  @Input() title: string = '';
  @Input() tag: string = '';
  @Input() tagTextColor: string = '';
  @Input() tagBackgroundColor: string = '';
  @Input() description: string = '';
  @Input() note: string = '';
  @Input() noteTextColor: string = '';
  @Input() noteBackgroundColor: string = '';

  @Input() listItems!: { icon: string; desc: string; }[];
}
